import Link from 'next/link'

const GENERIC_BANNER_COPY = new Set([
    'your trusted water treatment partner',
    'your trusted water treament partner',
])

export function Banner({ bannerText, bannerCtaText, bannerCta }) {
    const normalizedText = bannerText?.trim().toLowerCase()

    // Generic evergreen copy adds height without giving visitors timely information.
    if (!normalizedText || GENERIC_BANNER_COPY.has(normalizedText)) {
        return null
    }

    return (
        <div className="flex min-h-9 items-center justify-center bg-water-ink px-4 py-1.5 text-center text-white sm:px-6">
            <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
                <p className="text-xs font-medium leading-5 text-white/85">
                    {bannerText}
                </p>
                {bannerCta && bannerCtaText ? (
                    <Link
                        href={bannerCta}
                        className="flex-none text-xs font-semibold text-white underline decoration-white/35 underline-offset-4 transition-colors hover:decoration-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-water-ink"
                    >
                        {bannerCtaText} <span aria-hidden="true">→</span>
                    </Link>
                ) : null}
            </div>
        </div>
    )
}
